<template>
  <div class="button-with-description-box">
    <p>{{description}}</p>
    <button :class="buttonClass" @click="movePage()">{{buttonName}}</button>
  </div>
</template>

<script>
  export default {
    name: "ButtonWithDescriptionBox",

    props: {
      description: {
        type: String,
        required: true
      },
      buttonName: {
        type: String,
        required: true
      },
      buttonColor: {
        type: String,
        required: true
      },
      link: {
        type: Object,
      }
    },

    computed: {
      buttonClass() {
        return `${this.buttonColor}-ellipse_button`
      }
    },

    methods: {
      movePage() {
        this.$router.push({name: this.link.name, params: this.link.params})
      }
    }
  }
</script>

<style lang="scss" scoped>
  .button-with-description-box {
    @include ellipse;
    display: flex;
    flex-flow: column;
    justify-content: space-between;
    align-items: center;
    padding: 1rem;
    height: 17rem;
    background-color: $base_color;

    > button {
      width: 100%;
    }
  }
</style>